//cookie操作简单封装
var cookie = {
	get:function(name)
	{
		var arr=null;
		var reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
		if(name == "topicHistory"){
			// alert(document.cookie.match(reg))
		}
		if(arr=document.cookie.match(reg)){
			return decodeURIComponent(arr[2]);
		}else{
			return null;
		}
	},
	/**
	 * 写cookie
	 * @param {[type]} name  [description]
	 * @param {[type]} value [description]
	 *  //s20是代表20秒
		//h是指小时，如12小时则是：h12
		//d是天数，30天则：d30
		//不传，表示关闭浏览器就失效
	 */
	set:function(name,value,time,domain)
	{
		//var domain = window.location.hostname;
	    var domain = domain?domain:".eastmoney.com";
	    //var domain=window.location.hostname;
		// if(helper.bridge.isHybrid()){
	 //    	domain=window.location.hostname;
	 //    }
	 	// alert(domain);
	    var exp = new Date();

	    if(time){
		    var strsec = this.getsec(time);
		    exp.setTime(exp.getTime() + strsec*1);
		    document.cookie = name + "="+ encodeURIComponent(value) + ";domain="+domain+";path=/;expires=" + exp.toGMTString();
	    }else{
	    	document.cookie = name + "="+ encodeURIComponent(value) + ";domain="+domain+";path=/";
	    }
	},
	getsec:function(str)
	{
	   var str1=str.substring(1,str.length)*1;
	   var str2=str.substring(0,1);
	   if (str2=="s")
	   {
	        return str1*1000;
	   }
	   else if (str2=="h")
	   {
	       return str1*60*60*1000;
	   }
	   else if (str2=="d")
	   {
	       return str1*24*60*60*1000;
	   }
	},
	removeCookie: function (key, options) {
		if (this.get(key) === undefined) {
			return false;
		}

		// Must not alter options, thus extending a fresh object...
		this.get(key, '', $.extend({}, options, { expires: -1 }));
		return !this.get(key);
	}
}

module.exports = {
	get: cookie.get,
	set: cookie.set,
	getsec: cookie.getsec,
	removeCookie:cookie.removeCookie
};



//////////////////
// WEBPACK FOOTER
// ./src/module/helper/cookie.js
// module id = 2
// module chunks = 0